import { Component } from '@angular/core';
import { TopbarStateService } from './services/topbar-state.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],

})
export class AppComponent {
  title = 'keepout';
  public isLogged: boolean = false;
  constructor(private topbarState: TopbarStateService,
  ) {

  }
}
